// add fucnitonality for the accessibility toggle controls and preserve user selected state with localStorage

// the js to detect user preference and localstorage values is in bundle-header.js

const html = document.querySelector('html');
const contrastBtn = document.querySelector('.acctoggle__contrast');
const fontButton = document.querySelector('.acctoggle__fontsize');

// Provide a custom event to trigger when the font size is changed.
const fontSizeEvent = new Event('a11y-toggle-fontsize-change');

// functions to update localStorage with the user-selected state
const setFontsizeState = () => {
	if (html.classList.contains('accessibility__fontsize')) {
		localStorage.setItem('accessiblefontsize', 'enabled');
	} else {
		localStorage.setItem('accessiblefontsize', 'disabled');
	}
};

fontButton.addEventListener('click', () => {
	html.classList.toggle('accessibility__fontsize');
	setFontsizeState();
	// Dispatch the custom event.
	document.dispatchEvent(fontSizeEvent);
});
